module.exports = __webpack_public_path__ + "img/be49e4f.jpg";